module.exports = __webpack_public_path__ + "img/tab_02.40cc2f48.png";